import { render, staticRenderFns } from "./RingsPurchaseModal.vue?vue&type=template&id=81390d80&scoped=true"
import script from "./RingsPurchaseModal.vue?vue&type=script&lang=ts"
export * from "./RingsPurchaseModal.vue?vue&type=script&lang=ts"
import style0 from "./RingsPurchaseModal.vue?vue&type=style&index=0&id=81390d80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81390d80",
  null
  
)

export default component.exports